import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckIcon, HashIcon, PaperclipIcon } from "lucide-react";
import { channelMessages, channelName } from "../../data/process";
const EASE = [0.23, 1, 0.32, 1] as const;
export function ClientChannel({
  step,
  lastStep
}: {
  step: number;
  lastStep: number;
}) {
  const visible = channelMessages.filter(m => m.step <= step);
  return <div className="flex h-full min-h-0 flex-col border border-hairline bg-ink" data-id="element-298" data-mp="3lo9ojmqepcud">
      <div className="flex items-center justify-between border-b border-hairline px-4 py-3" data-id="element-299" data-mp="3gxji0668v3y3">
        <span className="flex items-center gap-1.5 font-mono text-[12px] tracking-[0.06em] text-white" data-id="element-300" data-mp="3by6o51gygwm0">
          <HashIcon className="h-3.5 w-3.5 text-body" aria-hidden="true" data-id="element-301" data-mp="37wv5xh0evdnu" />
          {channelName}
        </span>
        <span className="flex items-center gap-2 font-mono text-[10px] tracking-[0.14em] text-foot" data-id="element-302" data-mp="32y1sfol4jmno">
          <span className="is-round inline-block h-1.5 w-1.5 bg-[#3DDC84]" aria-hidden="true" data-id="element-303" data-mp="2xy5k5d5e992b" />
          DEDICATED CHANNEL
        </span>
      </div>

      <ul className="flex flex-1 flex-col justify-end gap-3 overflow-hidden px-4 py-4" aria-live="polite" aria-label="Client channel" data-id="element-304" data-mp="1pws3g8bvufoz">
        <AnimatePresence initial={false} data-id="element-305" data-mp="1gyq8a9etyh9m">
          {visible.map(m => {
          const studio = m.from === "studio";
          return <motion.li key={m.id} layout className={`flex max-w-[90%] gap-2.5 ${studio ? "self-start" : "flex-row-reverse self-end"}`} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: 6
          }} transition={{
            duration: 0.22,
            ease: EASE
          }} data-id="element-306" data-mp="1lxt556knph6i">
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center font-mono text-[10px] ${studio ? "bg-signal text-ink" : "border border-hairline text-white"}`} aria-hidden="true" data-id="element-307" data-mp="24ly13rv2nxur">
                  {studio ? "BH" : "YOU"}
                </span>
                <div className={studio ? "" : "text-right"} data-id="element-308" data-mp="54e8h1a6b7xn">
                  <p className="font-mono text-[10px] tracking-[0.1em] text-foot" data-id="element-309" data-mp="57a42iyjtkix">
                    {studio ? "BRANDHERO" : "YOU"} · {m.time}
                  </p>
                  <p className={`mt-1 px-3 py-2 text-left text-[13px] leading-snug md:text-[14px] ${studio ? "bg-card text-white" : "bg-white/[0.08] text-white"}`} data-id="element-310" data-mp="3rjz79t220lyi">
                    {m.text}
                  </p>
                  {"attachment" in m && <p className="mt-1.5 inline-flex items-center gap-1.5 border border-hairline px-2 py-1 font-mono text-[10px] tracking-[0.08em] text-body" data-id="element-311" data-mp="3dk7lh65aq19y">
                      <PaperclipIcon className="h-3 w-3" aria-hidden="true" data-id="element-312" data-mp="38nplejkwur3y" />
                      {m.attachment}
                    </p>}
                  {"approved" in m && <p className="mt-1.5 inline-flex items-center gap-1 bg-signal px-2 py-0.5 font-mono text-[10px] tracking-[0.12em] text-ink" data-id="element-313" data-mp="16s6so4aebsnw">
                      <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-314" data-mp="1jcc8oiun1rm2" />
                      APPROVED
                    </p>}
                </div>
              </motion.li>;
        })}
        </AnimatePresence>

        {step < lastStep && <li className="flex items-center gap-2 font-mono text-[10px] tracking-[0.12em] text-foot" aria-hidden="true" data-id="element-315" data-mp="vfg7ceyji9po">
            <span className="flex gap-1" data-id="element-316" data-mp="10f2jsm6jnlxf">
              {[0, 1, 2].map(i => <span key={i} className="typing-dot is-round inline-block h-1 w-1 bg-body" style={{
            animationDelay: `${i * 0.15}s`
          }} data-id="element-317" data-mp="15cktwfwas770" />)}
            </span>
            BRANDHERO IS TYPING
          </li>}
      </ul>

      <div className="border-t border-hairline px-4 py-3 font-mono text-[11px] tracking-[0.06em] text-foot" aria-hidden="true" data-id="element-318" data-mp="2grq03tvn0nvd">
        Message #{channelName}
      </div>
    </div>;
}